import {
    useMemo,
} from 'react'
import {
    ActionComponentsKey,
} from 'app/PoC/DataGridDemoPages/SkyNetDomainV2/SkyNetDomain.types'

export type ActionsMap = Record<ActionComponentsKey, JSX.Element>

type Props = {
    actionsMap: ActionsMap,
    toolbarActions: ActionComponentsKey[]
}

const useAllowedActionsMap = ({
    actionsMap,
    toolbarActions,
}: Readonly<Props>) => {
    return useMemo(() => {
        return Object.keys(actionsMap).reduce((acc, key) => {
            if (toolbarActions?.includes(key as ActionComponentsKey)) {
                acc[key] = actionsMap[key]
            }
            return acc
        }, {} as ActionsMap)
    }, [
        actionsMap,
        toolbarActions,
    ])
}

export default useAllowedActionsMap
